<template>
    <div>
        <vx-card title="USUÁRIOS" class="overflow-hidden mb-base border border-dashed d-theme-border-grey-light">
            <div slot="no-body">
                <div class="p-6 flex justify-between flex-row-reverse items-center text-center">
                    <div class="truncate">
                        <h2 class="mb-1 font-bold">
                            <number
                                ref="totalUsers"
                                :to="totalUsersQuantity"
                                :duration="0.6"
                                :delay="0.3"
                                easing="Power1.easeOut"
                            />
                        </h2>
                        <span>Usuários</span>
                    </div>
                    <feather-icon icon="UsersIcon" class="p-3 inline-flex rounded-full text-primary" :style="{background: `rgba(var(--vs-primary),.15)`}"></feather-icon>
                </div>

                <div class="line-area-chart">
                    <vue-apex-charts ref="apexChart" width='100%' type="area" height=255 :options="chartOptions" :series="chartData" />
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'

    export default {
        props : {
            users : {
                
            }
        },

        components : {
            VueApexCharts
        },

        data () {
            return {
                totalUsersQuantity : 0,
                chartData: [{
                        name: 'Usuários',
                        data: [2, 40, 36, 52, 38, 60, 53]
                    }],
                    analyticsData: {
                    subscribers: 309
                },
                chartOptions: {
                    xaxis: {
                        categories: [
                            'teste',
                            'teste2'
                        ]
                    },
                    grid: {
                        show: true,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        type: 'area',
                        dropShadow: {
                            enabled: true,
                            top: 5,
                            left: 0,
                            blur: 4,
                            opacity: 0.10,
                        },
                        toolbar: {
                            show: false,
                        },
                        sparkline: {
                            enabled: false
                        }
                    },
                    stroke: {
                        width: 5,
                        curve: 'smooth'
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            gradientToColors: ['#ea5455'],
                            shadeIntensity: 0,
                            type: 'vertical',
                            opacityFrom: 0.6,
                            opacityTo: 0,
                            stops: [0, 100, 100, 100]
                        },
                    },
                    colors: ['#ea5455'],
                    markers: {
                        size: 1,
                        hover: {
                            size: 5
                        }
                    },
                    tooltip: {
                        x: { show: true }
                    },
                }
            }
        },

        created () {
            let filters = this.$options.filters
            
            let weekDays = []
            let totalUsers = []
            let sumUser = 0;
            let lastWeek = '';

            this.users.forEach((user, i) => {
                let weekName = this.$t(filters.moment(user.date, 'ddd'));
                let sumTotals = false;

                if(lastWeek != weekName)
                    weekDays.push(weekName)
                
                sumUser++;
                if(typeof(this.users[i+1]) != 'undefined')
                    if(this.users[i+1].date != user.date) sumTotals = true

                if(this.users.length -1 == i) sumTotals = true

                if(sumTotals) {
                    totalUsers.push(sumUser)
                    sumUser = 0;
                }

                lastWeek = weekName;
            })
            
            this.totalUsersQuantity = totalUsers[totalUsers.length-1];

            this.$set(this.chartData[0], 'data', totalUsers)
            this.$set(this.chartOptions.xaxis, 'categories', weekDays)

        }
    }
</script>